import { Plus } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const PM_IMG =
  "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&q=85";

const ITEMS = [
  "Contractors",
  "Subcontractors",
  "Materials",
  "Project Schedules",
  "Site Progress",
  "Quality Control",
  "Communication",
  "Completion",
];

export const Management = () => (
  <section id="management" data-testid="management-section" className="relative overflow-hidden bg-[#0A111E] py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
      <div>
        <Reveal>
          <div className="mb-6 flex items-center gap-4">
            <span className="h-px w-12 bg-gradient-to-r from-[#C5A059] to-transparent" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.35em] text-[#C5A059]">Project Management</span>
          </div>
          <h2 className="font-serif text-3xl font-light uppercase leading-snug tracking-tight text-white sm:text-4xl lg:text-5xl">
            One Team. One Project. <span className="gold-text-gradient">Complete Control.</span>
          </h2>
          <p className="mt-8 max-w-xl text-base font-light leading-relaxed text-slate-300 sm:text-lg">
            Tyrell Property Services can manage your entire project — a single professional
            team coordinating every element, so you deal with one point of contact and a
            clear, accountable process.
          </p>
        </Reveal>
        <div className="mt-10 grid grid-cols-2 gap-3">
          {ITEMS.map((item, i) => (
            <Reveal key={item} delay={i * 0.06}>
              <div
                data-testid={`pm-item-${item.toLowerCase().replace(/\s+/g, "-")}`}
                className="flex items-center gap-3 border border-[#C5A059]/15 bg-[#0E1726]/60 px-4 py-3.5 transition-colors duration-300 hover:border-[#C5A059]/50"
              >
                <Plus size={14} className="shrink-0 text-[#C5A059]" />
                <span className="text-xs font-medium uppercase tracking-[0.18em] text-slate-200">{item}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.15}>
        <div className="relative">
          <div className="absolute -right-4 -top-4 h-full w-full border border-[#C5A059]/30" />
          <img
            src={PM_IMG}
            alt="Construction site managed by Tyrell Property Services — structural steelwork at dusk"
            className="relative h-[420px] w-full object-cover sm:h-[560px]"
          />
          <div className="absolute bottom-6 left-6 border border-[#C5A059]/30 bg-[#050B14]/85 px-6 py-4 backdrop-blur-md">
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#C5A059]">Managed End-to-End</span>
            <p className="mt-1 font-serif text-lg text-white">Planning → Completion</p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
